module.exports = __webpack_public_path__ + "static/media/day13_calendar.5b0dc44c.gif";